/* eslint-disable @typescript-eslint/no-explicit-any */
import PopupArrow from '../../components/Popup/PopupArrow'
import classNames from 'classnames'
import commonStyles from '../shared/styles.module.css'
import defaultProfile from './default-profile.svg'
import styles from './UserInfo.module.css'
import useLinkItemActive from './useLinkItemActive'
import { Alignment } from '../../components/Popup'
import { DefaultImage, DefaultLink } from '../shared'
import { Dropdown, DropdownMenu, DropdownMenuItem, DropdownMenuSeparator } from '../../components/Dropdown'
import { Icon } from '../../components/Icon'
import { getSafeImageSource } from '../../utils'
import type { MenuItemComponent, UserInfoProps, UserLink } from './types'
const profile = getSafeImageSource(defaultProfile)

function MenuItem({
  link,
  Link,
  shouldSetActiveClass = false,
  MenuItemComponent,
}: {
  link: UserLink
  Link: React.FC<any>
  MenuItemComponent: MenuItemComponent
  shouldSetActiveClass?: boolean
}) {
  const active = useLinkItemActive(link)
  if (link === 'separator') return <DropdownMenuSeparator />
  return (
    <MenuItemComponent>
      <Link
        data-axe-expect="color-contrast"
        className={classNames(styles.link, { [styles.active as string]: shouldSetActiveClass && active })}
        href={link.href}
      >
        {link.name}
      </Link>
    </MenuItemComponent>
  )
}

function UserInfo({
  text: { avatar: avatarImage = profile, name, links, myProfile },
  Link = DefaultLink,
  Image = DefaultImage,
}: UserInfoProps) {
  return (
    <Dropdown
      wrapperClassName={styles.dropdownMenu}
      Anchor={PopupArrow}
      marginInPx={5}
      anchorClassName={styles.arrow}
      alignContent={Alignment.RIGHT}
      trigger={
        <button
          data-axe-expect="aria-valid-attr-value"
          className={classNames(styles.trigger, styles.login, commonStyles.navigationLink)}
          id="header-login-dropdown-toggle"
        >
          <Image className={styles.image} height={36} width={36} src={avatarImage} alt={`${name} - Avatar`} />
          <span className={styles.label}>{myProfile}</span>
          <Icon name="chevronDown" size="400" color="fg-content-primary" className={styles.caret} />
        </button>
      }
    >
      <DropdownMenu>
        {links.map((link, index) => (
          <MenuItem link={link} Link={Link} key={index} MenuItemComponent={DropdownMenuItem} />
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}

export default UserInfo
